export default routesConfiguration;

/** @ngInject */
function routesConfiguration($stateProvider) {
  $stateProvider
    .state('configuration', {
      abstract: true,
      url: '/configuration',
      data: {
        hideNavbar: true
      },
      resolve: {
        user: SchoolCommonRoomService => SchoolCommonRoomService.getUser()
      }
    })
    .state('configuration.schoolCommonRooms', {
      url: '/schoolCommonRoom',
      views: {
        'content@': {
          component: 'listSchoolCommonRoomsComponent'
        },
        'footer@': {
          component: 'footerComponent'
        }
      },
      resolve: {
        schoolCommonRooms: SchoolCommonRoomService => SchoolCommonRoomService.getAll(true)
      }
    })
    .state('configuration.schoolCommonRooms.employees', {
      url: '/:id/employees',
      views: {
        'content@': {
          component: 'schoolCommonRoomEmployeesComponent'
        },
        'footer@': {
          component: 'footerComponent'
        }
      },
      resolve: {
        schoolCommonRoom: (SchoolCommonRoomService, $stateParams) => SchoolCommonRoomService.get($stateParams.id),
        employees: (EmployeeService, $stateParams) => EmployeeService.getSchoolCommonRoomEmployees($stateParams.id, true),
        unassignedEmployees: (EmployeeService, $stateParams) => EmployeeService.getUnassignedEmployees($stateParams.id, true),
        roles: EmployeeService => EmployeeService.getRoles()
      }
    });
}
